var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            close: _vm.closeDialog,
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.method != "add"
            ? _c(
                "el-button",
                {
                  staticClass: "mb8",
                  attrs: {
                    size: "medium",
                    icon: "el-icon-edit",
                    type: "warning",
                    disabled: !_vm.hasPermission("unmspace:cecUnmProject:edit"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handEditorView(_vm.method)
                    },
                  },
                },
                [_vm._v("编辑")]
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "英文名称",
                            prop: "nameEn",
                            rules: [
                              {
                                required: true,
                                message: "英文名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写英文名称",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.nameEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameEn", $$v)
                              },
                              expression: "inputForm.nameEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "中文名称",
                            prop: "nameCn",
                            rules: [
                              {
                                required: true,
                                message: "中文名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写中文名称",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.nameCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameCn", $$v)
                              },
                              expression: "inputForm.nameCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "编码",
                            prop: "code",
                            rules: [
                              {
                                required: true,
                                message: "编码不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写编码",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "code", $$v)
                              },
                              expression: "inputForm.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "单位",
                            prop: "unit",
                            rules: [
                              {
                                required: true,
                                message: "单位不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写单位",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.unit,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "unit", $$v)
                              },
                              expression: "inputForm.unit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "单价",
                            prop: "price",
                            rules: [
                              {
                                required: true,
                                message: "单价不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isFloatGteZero,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写单价" },
                            model: {
                              value: _vm.inputForm.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "price", $$v)
                              },
                              expression: "inputForm.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.method === "edit" || _vm.method === "view"
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "图片", prop: "", rules: [] } },
                            [
                              _c("ImageUploadCustom", {
                                attrs: {
                                  multiple: false,
                                  disabled: _vm.method === "view",
                                  otherPrams: _vm.otherPrams,
                                  action: "/unmfile/cecUnmFileupload",
                                  tip: "单个图片不要超过10M",
                                },
                                model: {
                                  value: _vm.inputForm.pic,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.inputForm, "pic", $$v)
                                  },
                                  expression: "inputForm.pic",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeDialog } },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }